export default __webpack_public_path__ + "static/media/iPhone_welcome_back-mobile.png.webp";